import React from "react";

import {
  LIFECYCLE_LABEL,
  LIFECYCLE_VARIANT,
} from "src/adminPanel/modulesV2/utils";
import { Module } from "src/api/modulesApi";
import { Button } from "src/base-components/Button";
import { Pill } from "src/base-components/Pill";

type Props = {
  module: Module;
  /** When provided, renders a "Change" button that opens the transition modal. */
  onChange?: () => void;
};

// Read-only lifecycle state of a module, with an optional trigger to change it.
// Shared by the operations-detail and create-operation modals.
export const LifecycleSummary: React.FC<Props> = ({ module, onChange }) => {
  const desired = module.desiredSpec.lifecycle_state;
  // Current (deployed) state; fall back to desired for not-yet-deployed modules.
  const current = module.spec?.lifecycle_state ?? desired;
  const inFlight = desired !== undefined && current !== desired;

  if (!current) {
    return null;
  }

  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
      <div className="flex items-center gap-2">
        <span className="font-inter-semibold-13px text-gray-900">
          Lifecycle
        </span>
        <Pill variant={LIFECYCLE_VARIANT[current]}>
          <Pill.Text fontType="text">{LIFECYCLE_LABEL[current]}</Pill.Text>
        </Pill>
        {inFlight && desired && (
          <span className="flex items-center gap-1 font-inter-normal-12px text-gray-500">
            →
            <Pill variant={LIFECYCLE_VARIANT[desired]}>
              <Pill.Text fontType="text">{LIFECYCLE_LABEL[desired]}</Pill.Text>
            </Pill>
            (in progress)
          </span>
        )}
      </div>
      {onChange && !inFlight && (
        <Button size="sm" variant="secondary" onClick={onChange}>
          Change
        </Button>
      )}
    </div>
  );
};
